import { Directive, ElementRef, Input, HostListener, OnChanges, HostBinding, SimpleChanges  } from '@angular/core';


@Directive({ selector: '[appSymptomDisplay]' })
export class SymptomDisplayDirective implements OnChanges {

    CurrentElement: ElementRef;

    @Input('symptomDisplay') symptomDisplay: string;
    @HostBinding('style.display')
    @Input() FlexDisplay: string;
    // @HostBinding('class')
    // @Input() classes: string;
    // @HostBinding('symptomDisplay')
    // @Input() symptomDisplayBinding: string;

    // @HostListener('mouseenter') onMouseEnter() {
    //    console.log(this.symptomDisplay);

    //    // this.FlexDisplay = 'none';
    // }

    ngOnChanges(changes: SimpleChanges) {
        const classlist = this.CurrentElement.nativeElement.classList;
        if (changes['symptomDisplay'].currentValue === 'top10') {
            if (classlist.contains('top10') === true) {
                this.FlexDisplay = 'flex';
            }else {
                this.FlexDisplay = 'none';
            }
        }else if (changes['symptomDisplay'].currentValue === 'common') {
            if (classlist.contains('common') === true) {
                this.FlexDisplay = 'flex';
            }else {
                this.FlexDisplay = 'none';
            }
        }else if (changes['symptomDisplay'].currentValue === 'redflags') {
            if (classlist.contains('red-flag') === true) {
                this.FlexDisplay = 'flex';
            }else {
                this.FlexDisplay = 'none';
            }
        }else if (changes['symptomDisplay'].currentValue === 'showall') {
            this.FlexDisplay = 'flex';
        }
    }

    constructor(el: ElementRef) {
        this.CurrentElement = el;
    }
}



// WEBPACK FOOTER //
// ./src/app/diagnosis-results/diagnosis-filter.directive.ts